import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturedManga from './components/FeaturedManga';
import LatestUpdates from './components/LatestUpdates';
import CategoryNav from './components/CategoryNav';
import AllMangaGrid from './components/AllMangaGrid';
import FAQSection from './components/FAQSection';
import { siteInfo } from '@/mocks/manga';

const homepageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: siteInfo.name,
  url: 'https://baki-manga.com',
  description: siteInfo.description,
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://baki-manga.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: siteInfo.name,
  url: 'https://baki-manga.com',
  description: siteInfo.description,
  foundingDate: '2020',
  contactPoint: {
    '@type': 'ContactPoint',
    email: siteInfo.email,
    contactType: 'customer service',
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="刃牙漫画在线观看 | 刃牙漫画免费在线阅读与下拉式全集在线看"
        description={siteInfo.description}
        canonicalUrl="https://baki-manga.com"
        schema={{ ...homepageSchema, ...orgSchema }}
      />
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedManga />
          <LatestUpdates />
          <CategoryNav />
          <AllMangaGrid />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}